import type { ExerciseStatus } from "sj-ui-toolkit/src/api/types/tournamentTypes";
type TournamentStatus = "in_progress" | "not_started" | "completed";

interface TournamentStatusResult {
  status: TournamentStatus;
  statusText: string;
  buttonText: string;
}

export const exerciseStatusText = (status: ExerciseStatus): string => {
  switch (status) {
    case "passed":
      return "Completed";
    case "in_progress":
      return "Resume";
    case "not_started":
      return "Start";
    case "failed":
      return "Retry";
    default:
      return "Unknown Status";
  }
};

export const hasTournamentStarted = (startDate: string | Date): boolean =>
  new Date(startDate) <= new Date();

export const formatTournamentStart = (startDate: string | Date): string =>
  new Date(startDate).toLocaleString(undefined, { dateStyle: "long", timeStyle: "short" });

export const calculateTournamentStatus = (
  startDate: string | Date,
  finishDate: string | Date,
  isEnrolled: boolean
): TournamentStatusResult => {
  const now = new Date();
  const finish = new Date(finishDate);

  const returnVal: TournamentStatusResult = {
    status: "in_progress",
    statusText: "Tournament in Progress",
    buttonText: isEnrolled ? "Unenroll from Tournament" : "Enroll in Tournament",
  };

  // Determine status
  if (!hasTournamentStarted(startDate)) {
    returnVal.status = "not_started";
    returnVal.statusText = "Upcoming Tournament";
  }
  if (finish < now) {
    returnVal.status = "completed";
    returnVal.statusText = "Tournament Completed";
  }

  return returnVal;
};
